import React from "react";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppSimpleLink } from "@/lib/brand";

const WhatsAppFloat = () => {
  return (
    <a
      href={buildWhatsAppSimpleLink()}
      target="_blank"
      rel="noreferrer"
      aria-label="Contacter Casa Vino sur WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 transition-transform">
        <MessageCircle className="w-6 h-6" strokeWidth={1.8} />
      </span>
      <span className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap text-xs tracking-[0.2em] uppercase bg-[#1A1617] text-[#F9F6F0] px-3 py-1.5 rounded opacity-0 group-hover:opacity-100 transition-opacity">
        Discuter sur WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppFloat;
